import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

//#region internal button styles
const SFButton = ({
  sx,
  id,
  children,
  variant,
  size,
  type,
  onClick,
  fullWidth,
  disabled = false,
  className,
  startIcon,
  endIcon,
  href,
  onMouseOver,
  onMouseOut,
  ariaLabel,
  ...props
}) => {
  const navigate = useNavigate();

  if (href) {
    onClick = () => navigate(href);
  }

  return (
    <Button
      id={id}
      variant={variant}
      size={size}
      type={type}
      onClick={onClick}
      sx={{ ...sx, height: sx && sx.height ? sx.height : "100%" }}
      fullWidth={fullWidth}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      {...(ariaLabel && { "aria-label": ariaLabel })}
      {...(className && { className: className })}
      {...props}
    >
      {children}
    </Button>
  );
};

SFButton.defaultProps = {
  id: null,
  variant: "primary",
  size: "medium",
  disabled: false,
  children: null,
  type: "submit",
  onClick: null,
  fullWidth: false,
  fullHeight: false,
  startIcon: null,
  endIcon: null,
  href: null,
};

SFButton.propTypes = {
  id: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "utility",
    "text-link",
    "text-link-secondary",
    "hovered",
    "ey-disabled",
    "ey-child-disabled",
    "white",
    "toolbar",
    "transparent",
  ]),
  type: PropTypes.oneOf(["submit", "reset", "button"]),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullWidth: PropTypes.bool,
  fullHeight: PropTypes.bool,
  sx: PropTypes.object,
  startIcon: PropTypes.object,
  endIcon: PropTypes.object,
  href: PropTypes.string,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
};
//#endregion

export default SFButton;
